module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/offline-collector-3.9c950791.svg";